<template>
  <section class="legacy-page-placeholder">
    <h2>历史功能页</h2>
    <p>该页面暂未配置内容。</p>
  </section>
</template>

<style scoped>
.legacy-page-placeholder {
  padding: 32px;
  color: #1f2937;
}
</style>
